export const RUSSIA_CODE = 'россия';
export const FREE_DELIVERY_PRICE_TRIGGER = 5000;
export const EKATERINBURG = 'екатеринбург';
export const SVERDLOVSKAYA_OBLAST = 'свердловская область';
